import { Component, OnInit, HostListener } from '@angular/core';

import { ViewChild, ElementRef } from '@angular/core';

import { CommonModule } from '@angular/common';

// Dialog popups
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Additional data popups for the different processes
import { VertebralLevelsAdComponent } from '../../popups/additional-data-popups/vertebral-levels-ad/vertebral-levels-ad.component';

// Angular material components
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

// Custom components
import { WaitingSpinnerComponent } from '../../utils/waiting-spinner/waiting-spinner.component';

// Services
import { UserAuthenticationService } from '../../../services/firestore/user-authentication.service';
import { LanguageService } from '../../../services/language/language.service';
import { ControllerService } from '../../../services/controller/controller.service';
import { DicomService } from '../../../services/dicom/dicom.service';
import { UtilsService } from '../../../services/utils/utils.service';
import { GlobalVariables } from '../../../constants/global';


@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [
    // Angular modules
    CommonModule, 
    // Material design modules
    MatMenuModule, 
    MatIconModule,
    MatButtonModule,
    // Custom modules
    WaitingSpinnerComponent,
  ],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.css'
})
export class LandingPageComponent implements OnInit {

  public windowWidth: number;

  displayWaitingSpiner = false
  waitingMessage = ''
  displayCanvas = false

  button_pushed:string = ''

  lowResolutioinPosImageLoaded = false
  posImageOnChangeListenerIsActive = false

  applicationState = 0
  optionMenu_Load_value:string = ''
  optionMenu_Patient_value:string = ''
  optionMenu_Study_value:string = ''
  optionMenu_Series_value:string = ''
  optionMenu_Process_value:string = ''
  optionMenu_Load_OptionList:any = []
  optionMenu_Patient_OptionList:any = []
  optionMenu_Study_OptionList:any = []
  optionMenu_Series_OptionList:any = []
  optionMenu_Process_OptionList:any = []
  optionMenu_Download_OptionList:any = []

  // Control variables
  loadedFromProject = false 

  // Variables to be stored
  currentSliceIndexes_artifacts:any = []
  currentSliceIndexes_overflow:any = []
  currentSliceIndexes_vertebralLevels:any = []

  // Software variables
  nImagesInSerie = 0
  currentLineIndex:number = 0
  currentSliceIndex = 0
  currentSliceIndexes:any = []
  positioningImageList:any = null
  posImage_index = 0
  posImage_nColumnsOffset = 0
  posImage_nRowsOffset = 0
  posImage_nColumns = 0
  posImage_nRows = 0
  posImage_jump = GlobalVariables.dcmImagesUploading['largestJump']
  //classMapList:any = null
  classMapBinList:any = null
  colorFactor:number = 0.5
  additionalInformationDict:any = {}

  singleSliceSelection:boolean = GlobalVariables.dcmImagesUploading['singleSliceSelection']
  maxNumberOfSlicesForClassification:number = GlobalVariables.dcmImagesUploading['maxNumberOfSlicesForClassification']
  classMapCorrected:boolean = false // Indicates if the data contains corrections that can be used for training
  nRemainingAnalysis = null

  @ViewChild('canvasElementLeft') canvasElementLeft!: ElementRef;
  @ViewChild('canvasElementRight') canvasElementRight!: ElementRef;
  @ViewChild('canvasElementRight_Overlay') canvasElementRight_Overlay!: ElementRef;
  @ViewChild('canvasElementLeft_TextOverlay') canvasElementLeft_TextOverlay!: ElementRef;


  @ViewChild('fileInput_DICOM') fileInput_DICOM: ElementRef;
  @ViewChild('fileInput_Project') fileInput_Project: ElementRef;


  constructor(
    public userAuthenticationService:UserAuthenticationService,
    public controllerService: ControllerService,
    public languageService: LanguageService,
    public dicomService:DicomService,
    public utilsService:UtilsService,
    public dialog: MatDialog,
  ){
    this.windowWidth = window.innerWidth;
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.windowWidth = (event.target as Window).innerWidth;
  }


  ngOnInit(): void {
    // Prevent context menu option for right click (download image as...)
    document.addEventListener('contextmenu', function(event) {
      event.preventDefault();
    });
    // Set aplication state 
    this.setApplicationState(0)
    // Subscribe to the number of remaining analysis
    this.userAuthenticationService.getNRemainingAnalysisValue().subscribe(value => {
      this.nRemainingAnalysis = value;
    })
    // Subscribe to language selection to update the view if the language changes
    this.subscribeToLanguageService()
  }




  setApplicationState(state){
    // Detach onChange listener for positioning image if exists
    if(state < 5) this.posImageOnChangeListenerIsActive = false
    // Reset the necessary view items
    this.resetView(state)
    // Reset the necessary component variables
    this.resetVariables(state)
    // State 0: Application just opened
    //    Load menu
    this.optionMenu_Load_value = this.languageService.Strings.fnStrings.button_load
    this.optionMenu_Load_OptionList = [
      this.languageService.Strings.fnStrings.button_loadDicom
    ]
    // State 1: Patient has not been selected
    if(state==1){
      this.optionMenu_Patient_OptionList = this.dicomService.getPatientInformationList()
    }
    // State 2: Patient selected
    if(state==2){
      this.optionMenu_Study_OptionList = this.dicomService.getStudyInformationList()
    }
    // State 3: Study seelcted
    if(state==3){
      this.optionMenu_Series_OptionList = this.dicomService.getSeriesInformationList()
    }
    // State 4: Series selected
    if(state==4){
      this.optionMenu_Process_OptionList = this.dicomService.getProcessesInformationList()
    }
    // State 5: Series Loaded
    if(state==5){
      this.colorFactor = 0.5
      this.displayCurrentImageNumber()
      this.optionMenu_Process_value = this.languageService.Strings.processesString[this.dicomService.getCurrentProcessKey()]
    }
    // State 6: Image classified
    // Store the current application state
    this.applicationState = state
  }



  resetView(state){
    // State 0: Application just opened
    // State 1: Patient has not been selected
    if(state <= 1){
      this.optionMenu_Patient_value = this.languageService.Strings.fnStrings.button_selectPatient
      this.optionMenu_Patient_OptionList = []
    }
    // State 2: Patient selected
    if(state <= 2){
      this.optionMenu_Study_value = this.languageService.Strings.fnStrings.button_selectStudy
      this.optionMenu_Study_OptionList = []
    }
    // State 3: Study seelcted
    if(state <= 3){
      this.optionMenu_Series_value = this.languageService.Strings.fnStrings.button_selectSeries
      this.optionMenu_Series_OptionList = []
    }
    // State 4: Series selected
    if(state <= 4){
      this.optionMenu_Process_value = this.languageService.Strings.fnStrings.button_selectProcess
      this.optionMenu_Process_OptionList = []
      // Clear the canvas views
      this.clearCanvas()
    }
    // State 5: Series Loaded
    if(state <= 5){}
    // State 6: Data specified
    if(state <= 6){}
    // State 7: Lines (artifacts | overflow | vertebralLevels)
    if(state <= 7){}
  }


  resetVariables(state){
    // State 6: Data specified
    if(state <= 5){
      this.additionalInformationDict = {}
    }
    // State 7: Lines (artifacts | overflow | vertebralLevels)
    if(state <= 6){
      this.button_pushed = ''
    }
  }







  // ----- Button Actions ----- //

  async optionMenuClick_Load(index){
    if(index == 0){
      this.fileInput_DICOM.nativeElement.click();
    }else if(index == 1){
      this.fileInput_Project.nativeElement.click();
    }
  }

  optionMenuClick_Patient(index){
    this.dicomService.selectCurrentPatient(index)
    this.optionMenu_Patient_value = this.dicomService.getPatientInformationFromIndex(index)
    this.setApplicationState(2)
  }

  optionMenuClick_Study(index){
    this.dicomService.selectCurrentStudy(index)
    this.optionMenu_Study_value = this.dicomService.getStudyInformationFromIndex(index)
    this.setApplicationState(3)
  }

  optionMenuClick_Series(index){
    this.dicomService.selectCurrentSeries(index)
    this.optionMenu_Series_value = this.dicomService.getSerieInformationFromIndex(index)
    this.setApplicationState(4)
  }

  async optionMenuClick_Process(index){
    this.displayCanvas = true
    // Select the current process
    this.dicomService.selectCurrentProcess(index)
    // Initialize the canvas size
    this.initializeCanvasSize()
    // Display the waiting popup
    this.waitingMessage = this.languageService.Strings.fnStrings.waitingMessage_LoadSeries
    this.displayWaitingSpiner = true
    // Specify that the low resolution pos image has not been loaded 
    this.lowResolutioinPosImageLoaded = false
    // Sepecify that the posImageOnChangeListener is active
    this.posImageOnChangeListenerIsActive = true
    // Reset the jump value for the custom on change listener 
    this.posImage_jump = GlobalVariables.dcmImagesUploading['largestJump']
    // Load the serie data
    let resultDict = await this.dicomService.loadSeriesData( this.loadSeriesData_Callback.bind(this) )
    // hasOwnProperty
    if(!resultDict['resultOk']){
      this.displayWaitingSpiner = false
      return
    } 
  }
  async loadSeriesData_Callback(resultDict){
    // If the result is not ok 
    if(!resultDict['resultOk']){
      this.displayWaitingSpiner = false
      return
    }
    // If the on change listener is not active, ignore the result
    if(!this.posImageOnChangeListenerIsActive){
      return
    }
    // If the jump is largest that the lust jump loaded, return. Else, update the value
    if(resultDict['jump'] > this.posImage_jump) return
    this.posImage_jump = resultDict['jump']
    // If the result is ok, go on
    this.positioningImageList = resultDict['posImageList']
    this.nImagesInSerie = resultDict['nImagesInSerie']
    this.posImage_nRows = resultDict['nRows']
    this.posImage_nRowsOffset = resultDict['nRowsOffset']
    // If it is the first version of positioning image, the index is set to 0
    if(!this.lowResolutioinPosImageLoaded) this.posImage_index = 0
    // Display positioning image
    await this.displayPositioningImage()
    // If it is just un update of the positioning image, the process stops here
    if(this.lowResolutioinPosImageLoaded) return
    this.lowResolutioinPosImageLoaded = true
    // Display current slice
    // Use floor cause if the serie has only 1 image, round results in sliceIndex=1 and there is an error
    this.currentSliceIndexes = [Math.floor(this.nImagesInSerie/2)]
    this.currentLineIndex = 0;
    this.currentSliceIndex = this.currentSliceIndexes[this.currentLineIndex];
    this.displayPositioningImageLine()
    // TODO: TBD - Desacoplar
    await this.dicomService.displayImageLeft(this.canvasElementLeft.nativeElement, this.currentSliceIndex)
    this.displayCurrentImageNumber()
     // Stop waiting popup
    this.displayWaitingSpiner = false
    // Increase application state
    this.setApplicationState(5)
  }
  



  buttonAction_data() {
    if (this.dicomService.getCurrentProcessKey() == 'vertebralLevels'){
      // Normal data pop-up
      this.dialog.open(
        VertebralLevelsAdComponent,
        {
          disableClose: true,
          data: {additionalInformationDict:this.additionalInformationDict},
          width: '1000px',   
        } 
      ).afterClosed().subscribe(result => this.shouldUpdateAdditionalInformationDict(result))
    }
  }
  
  async shouldUpdateAdditionalInformationDict(result){
    if(result['shouldUpdateAdditionalData']){
      this.additionalInformationDict = this.utilsService.deepCopyDict(result['additionalInformationDict'])
      this.button_pushed = ''
      // Reset how the positioning image is visualized
      this.currentSliceIndexes = [this.currentSliceIndex]
      this.displayPositioningImageLine()
    }
    if(Object.keys(this.additionalInformationDict).length > 0){
      this.setApplicationState(6)
      this.updateCurrentSliceIndexes()
    }
  }
  updateCurrentSliceIndexes(){
    this.currentSliceIndexes_artifacts = this.updateCurrentSliceIndexesForSpecificProcess('artifacts')
    this.currentSliceIndexes_overflow = this.updateCurrentSliceIndexesForSpecificProcess('overflow')
    this.currentSliceIndexes_vertebralLevels = this.updateCurrentSliceIndexesForSpecificProcess('vertebralLevels')
  }
  updateCurrentSliceIndexesForSpecificProcess(process){
    let nPosImageLines = 0
    if(process == 'artifacts'){
      if(this.additionalInformationDict['artifacts']){
        nPosImageLines = 2 * this.additionalInformationDict['nArtifactRanges']
      }
    }else if(process == 'overflow'){
      if(this.additionalInformationDict['overflow']){
        nPosImageLines = 2 * this.additionalInformationDict['nOverflowRanges']
      }
    }else if(process == 'vertebralLevels'){
      nPosImageLines = this.additionalInformationDict['nVertebralLevelLines']
    }
    let currentSliceIndexes = Array(nPosImageLines).fill(null)
    return currentSliceIndexes
  }


  storeCurrentSliceIndexes(){
    // Store the previous lines in the corresponding list
    if(this.button_pushed === 'artifacts'){
      this.currentSliceIndexes_artifacts = this.utilsService.deepCopyDict(this.currentSliceIndexes)
    }else if(this.button_pushed === 'overflow'){
      this.currentSliceIndexes_overflow = this.utilsService.deepCopyDict(this.currentSliceIndexes)
    }else if(this.button_pushed === 'vertebralLevels'){
      this.currentSliceIndexes_vertebralLevels = this.utilsService.deepCopyDict(this.currentSliceIndexes)
    }
  }





  buttonAction_setLines(action:string){
    // Store the previous lines in the corresponding list
    this.storeCurrentSliceIndexes()
    // Update the state
    this.button_pushed = action
    if(this.button_pushed === 'artifacts'){
      this.currentSliceIndexes = this.utilsService.deepCopyDict(this.currentSliceIndexes_artifacts)
    }else if(this.button_pushed === 'overflow'){
      this.currentSliceIndexes = this.utilsService.deepCopyDict(this.currentSliceIndexes_overflow)
    }else if(this.button_pushed === 'vertebralLevels'){
      this.currentSliceIndexes = this.utilsService.deepCopyDict(this.currentSliceIndexes_vertebralLevels)
    }
    // Update the slice indexes
    this.currentLineIndex = 0;
    this.currentSliceIndex = this.currentSliceIndexes[this.currentLineIndex];

    this.setApplicationState(7)
    this.displayPositioningImageLine()
  }







  buttonAction_results() {
    this.utilsService.displayPatientIdPopup(this.setPatientIdForResults_callback.bind(this))
  }
  setPatientIdForResults_callback(resultDict){
    // If button cancel was clicked, return
    if(!resultDict['shouldGenerateResults']) return
    // Generate the results
    let proposedPatientId = resultDict['proposedPatientId']
    let proposedStudyId = resultDict['proposedStudyId']
    // Display the waiting popup
    this.waitingMessage = this.languageService.Strings.fnStrings.waitingMessage_GeneratingResults
    this.displayWaitingSpiner = true
    // Save the current slice indexes
    this.storeCurrentSliceIndexes()
    // Execute the backend method
    this.dicomService.generateResults(this.currentSliceIndexes_vertebralLevels, this.currentSliceIndexes_artifacts, this.currentSliceIndexes_overflow,
      this.additionalInformationDict, this.nImagesInSerie, 
      this.posImage_nRows, this.posImage_nRowsOffset, proposedPatientId, proposedStudyId,
      this.generateResults_Callback.bind(this))
  }
  generateResults_Callback(resultDict){
    // If the result is not ok 
    if(!resultDict['resultOk']){
      this.displayWaitingSpiner = false;
      if (resultDict['error'] === 'There are not enough images above or below the selected range.'){
        const uploadImageOffset = GlobalVariables.processes.vertebralLevels.uploadImageOffset;
        const errorMessage = this.languageService.Strings.feedbackStrings.enoughOffsetImages
        this.utilsService.displaySnackBar(errorMessage.replace("${0}", uploadImageOffset.toString()), 5000);
      }
      return
    }
    // If the result is ok, go on
    let resultsZipUrl = resultDict['resultsZipUrl'];
    let resultsZipFilename = resultDict['resultsZipFilename'];
    // Stop waiting popup
    this.displayWaitingSpiner = false;
    // Download results file
    this.utilsService.downloadFile(resultsZipUrl, resultsZipFilename);
  }

  verifyAllNonNullAndNumeric(targetArray){
    const allNonNullAndNumeric = targetArray.every(level => {
      return level !== null && typeof level === 'number';
    });
    return allNonNullAndNumeric
  }
  resultsCanBeGenerated(){
    // Evaluate application state
    if(this.applicationState < 6) return false
    // Evaluate vertebral levels
    if(!this.additionalInformationDict['vertebralLevels']) return false
    if(!this.verifyAllNonNullAndNumeric(this.currentSliceIndexes_vertebralLevels)) return false
    // Evaluate artifact ranges
    if(this.additionalInformationDict['artifacts']){
      if(!this.verifyAllNonNullAndNumeric(this.currentSliceIndexes_artifacts)) return false
    }
    // Evaluate overflow ranges
    if(this.additionalInformationDict['overflow']){
      if(!this.verifyAllNonNullAndNumeric(this.currentSliceIndexes_overflow)) return false
    }
    // If all tests passed, return true
    return true
  }





















  // ----- Methods to manage files selection ----- //
  public async onFileSelected_DICOM(event:any){   
    // Get the file array (make a copy so the event can be reset to its default value)
    let fileArray = Array.from(event.target.files);
    // Verify that there is at least one file selected
    if(fileArray.length == 0){
      return
    }
    // Display the waiting popup
    this.waitingMessage = this.languageService.Strings.fnStrings.waitingMessage_LoadDicom
    this.displayWaitingSpiner = true
    // Array with the selected files
    this.dicomService.loadDicomdirStructure(fileArray, this.onFileSelected_DICOM_callback.bind(this))
    // Reset the event to its default value
    event.target.value = '';
  }
  public onFileSelected_DICOM_callback(resultDict:any){
    // Close the waiting popup 
    this.displayWaitingSpiner = false
    // If not resultOk, there are not available images. Notify the user and finish the process
    if(!resultDict['resultOk']){
      this.utilsService.displayInformationPopupComponent(
        this.languageService.Strings.popups.title_nonDcmFiles,
        this.languageService.Strings.popups.text_nonDcmFiles
      )
      return
    }
    // If there are badly formated images, ask the user for the decision
    if(resultDict['thereIsBadlyAnonymizeData']){
      this.utilsService.displayDecisionPopupComponent(
        this.languageService.Strings.popups.title_badlyAnonymizedDcm,
        this.languageService.Strings.popups.text_badlyAnonymizedDcm,
        this.onFileSelected_DICOM_AcceptBadlyAnonymizedData_callback.bind(this)
      )
      return
    }
    // Appdate the application state
    this.setApplicationState(1)
  }
  public onFileSelected_DICOM_AcceptBadlyAnonymizedData_callback(accepted:boolean){
    // If the badly anonymized data is accepted, go on to next application state
    if(accepted){
      // Appdate the application state
      this.setApplicationState(1)
      // Finish the uploading process
      return
    }
    // If the badly anonymized data is not accepted, format the dicom structure again
    let resultDict = this.dicomService.formatDicomStructure_RemoveBadlyAnonymizedData()
    if(!resultDict['resultOk']){
      this.utilsService.displayInformationPopupComponent(
        this.languageService.Strings.popups.title_nonDcmFiles,
        this.languageService.Strings.popups.text_nonDcmFiles
      )
      return
    }
    // Appdate the application state
    this.setApplicationState(1)
  }






  












  // ----- UI - Methods ----- //

  async canvasRight_onWheel(event){
    if(this.applicationState >= 5){
      if(event.deltaY > 0) await this.updateSliceIndex(+1)
      if(event.deltaY < 0) await this.updateSliceIndex(-1)
    }
  }

  async canvasRight_onClick(event){
    if(this.applicationState >= 5){
      let rect = this.canvasElementLeft.nativeElement.getBoundingClientRect(); 
      let y = event.clientY - rect.top;
      // Calculate the slice index
      let sliceIndex = Math.round((y - this.posImage_nRowsOffset) / (this.posImage_nRows / this.nImagesInSerie))
      this.currentSliceIndex = Math.max(Math.min(sliceIndex, this.nImagesInSerie-1), 0)
      // Move also the first line if the process state is "range image selection"
      this.currentSliceIndexes[this.currentLineIndex] = this.currentSliceIndex
      await this.dicomService.displayImageLeft(this.canvasElementLeft.nativeElement, this.currentSliceIndex)
      this.displayPositioningImageLine() // Update the positioning image line
      this.displayCurrentImageNumber()
      // Store the current slice indexes
      this.storeCurrentSliceIndexes()
    }
  }

  async canvasRight_onRightClick(event){
    if(this.applicationState >= 7){
      event.preventDefault()
      // Switch reference lines if process state is "range image selection"
      const nSliceIndexes = this.currentSliceIndexes.length
      if (this.currentLineIndex < (nSliceIndexes-1)) this.currentLineIndex += 1;
      else this.currentLineIndex = 0;
      this.currentSliceIndex = this.currentSliceIndexes[this.currentLineIndex]
      // Update the positioning image line
      //    If the slice index havent been set yet (null), set it according to the clicked position
      let proposedLineIndex:number = null
      if (this.currentSliceIndex === null){
        // Calculate the slice index
        let rect = this.canvasElementLeft.nativeElement.getBoundingClientRect(); 
        let y = event.clientY - rect.top;
        let sliceIndex = Math.round((y - this.posImage_nRowsOffset) / (this.posImage_nRows / this.nImagesInSerie))
        proposedLineIndex = Math.max(Math.min(sliceIndex, this.nImagesInSerie-1), 0)
      }
      this.displayPositioningImageLine(proposedLineIndex)     
      // TODO: Desacoplar
      if (this.currentSliceIndex !== null){
        await this.dicomService.displayImageLeft(this.canvasElementLeft.nativeElement, this.currentSliceIndex)
      }
      // Display image number
      this.displayCurrentImageNumber()
      // Store the current slice indexes
      this.storeCurrentSliceIndexes()
    }
  }






  // ----- Internal methods according to user actions ----- //
  async updateSliceIndex(increment){
    this.currentSliceIndex = Math.max(Math.min(this.currentSliceIndex + increment, this.nImagesInSerie-1), 0)
    // Move the line
    if(this.applicationState <= 7){
      this.currentSliceIndexes[this.currentLineIndex] = this.currentSliceIndex
    }
    await this.dicomService.displayImageLeft(this.canvasElementLeft.nativeElement, this.currentSliceIndex)
    this.displayPositioningImageLine()
    this.displayCurrentImageNumber()
    // Store the current slice indexes
    this.storeCurrentSliceIndexes()
  }

  updatePositioningImageIndex(increment:number){
    this.posImage_index += increment
    if(this.posImage_index >= this.positioningImageList.length) this.posImage_index = 0
    if(this.posImage_index < 0) this.posImage_index = this.positioningImageList.length - 1
    this.displayPositioningImage()
  }
  

















  // ----- Methods to display images in the canvas ----- //

  clearCanvas(){
    try{
      let ctx_r = this.canvasElementRight.nativeElement.getContext('2d');
      ctx_r.clearRect(0, 0, this.canvasElementRight.nativeElement.width, this.canvasElementRight.nativeElement.height);

      let ctx_ro = this.canvasElementRight_Overlay.nativeElement.getContext('2d');
      ctx_ro.clearRect(0, 0, this.canvasElementRight_Overlay.nativeElement.width, this.canvasElementRight_Overlay.nativeElement.height);

      let ctx_l = this.canvasElementLeft.nativeElement.getContext('2d');
      ctx_l.clearRect(0, 0, this.canvasElementLeft.nativeElement.width, this.canvasElementLeft.nativeElement.height);

      let ctx_lto = this.canvasElementLeft_TextOverlay.nativeElement.getContext('2d');
      ctx_lto.clearRect(0, 0, this.canvasElementLeft_TextOverlay.nativeElement.width, this.canvasElementLeft_TextOverlay.nativeElement.height);
    }catch{}
  }



  loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve(img);
        img.onerror = err => reject(err);
    });
  }

  async displayPositioningImage(){
    // Display the image
    let ctx = this.canvasElementRight.nativeElement.getContext('2d');
    // target canvas
    if(this.applicationState < 5){
      this.canvasElementRight.nativeElement.width = 512;  
      this.canvasElementRight.nativeElement.height = 512; 
      this.canvasElementRight.nativeElement.style.width = '512px';  
      this.canvasElementRight.nativeElement.style.height = '512px';
      ctx.fillStyle = "black";
    }
    // display image
    try {
        const img = await this.loadImage(this.positioningImageList[this.posImage_index]);
        ctx.drawImage(img, 0, 0);
    } catch (err) {
        console.error(`Error loading image: ${err}`);
    }
  }

  getRowIndex(sliceIndex){
    return Math.round(this.posImage_nRowsOffset + sliceIndex * (this.posImage_nRows / this.nImagesInSerie))
  }
  
  displayPositioningImageLine(proposedLineIndex:number=null){
    // TODO: Under test
    if(proposedLineIndex !== null){
      this.currentSliceIndexes[0] = proposedLineIndex
      this.currentSliceIndex = proposedLineIndex
    }
    // -- Standard situation -- //
    const nSliceIndexes = this.currentSliceIndexes.length;
    // Get the context
    let ctx = this.canvasElementRight_Overlay.nativeElement.getContext('2d');
    // Clean the existing information
    ctx.clearRect(0, 0, this.canvasElementRight_Overlay.nativeElement.width, this.canvasElementRight_Overlay.nativeElement.height);
    // Draw lines
    const rowIndex_current = this.getRowIndex(this.currentSliceIndex);
    this.drawLine(ctx, rowIndex_current, '#0085a3');
    for (let i=0; i<nSliceIndexes; i++) {
      let rowIndex = this.getRowIndex(this.currentSliceIndexes[i]);
      if (rowIndex != rowIndex_current){
        this.drawLine(ctx, rowIndex, '#ffffff');
      }
    }
    // Sort Slices Indexes array
    this.currentSliceIndexes.sort((a, b) => a - b);
    this.currentLineIndex = this.currentSliceIndexes.indexOf(this.currentSliceIndex)
    // Display the text
    let minIndex = Math.min(...this.currentSliceIndexes)
    let maxIndex = Math.max(...this.currentSliceIndexes)
    let textStr = (minIndex+1).toString() + ' - ' + (maxIndex+1).toString()
    if(this.singleSliceSelection) textStr = (minIndex+1).toString()
    //this.drawText(ctx, textStr, 5, 21)
    //  Calcular el ancho del texto para posicionarlo a la derecha
    let textWidth = ctx.measureText(textStr).width;
    //  Posicionar a la derecha (ancho del canvas - ancho del texto - margen de 5px)
    let xPosition = this.canvasElementRight_Overlay.nativeElement.width - textWidth - 5;
    this.drawText(ctx, textStr, xPosition, 21);
    // Draw vertebral levels text if needed
    if (this.dicomService.getCurrentProcessKey() == 'vertebralLevels' && this.button_pushed === 'vertebralLevels'){
      if (nSliceIndexes > 1) this.drawVertebralLevelsText(ctx);
    }
  }

  drawLine(ctx: CanvasRenderingContext2D, rowIndex:number, color:string){
    ctx.beginPath();
    ctx.moveTo(0, rowIndex);
    ctx.lineTo(this.canvasElementRight_Overlay.nativeElement.width, rowIndex);
    ctx.strokeStyle = color;
    ctx.stroke();
  } 
  drawRectangle(ctx: CanvasRenderingContext2D, rowIndex_bot:number, rowIndex_top:number, color:string, opacity:number){
    // Draw the transparent rectangle between the lines
    let minRow = Math.min(rowIndex_bot, rowIndex_top)
    let maxRow = Math.max(rowIndex_bot, rowIndex_top)
    let rectangleHeight = maxRow - minRow;
    ctx.globalAlpha = opacity; // Adjust this value to the desired transparency (0 = fully transparent, 1 = fully opaque)
    ctx.fillStyle = color;
    ctx.fillRect(0, minRow, this.canvasElementRight_Overlay.nativeElement.width, rectangleHeight);
    ctx.globalAlpha = 1; // Reset the transparency for the lines
  }
  drawText(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, fontSize:number=16) {
    ctx.fillStyle = '#ffffff';
    ctx.font = fontSize + 'px arial'; 
    ctx.fillText(text, x, y);
  }
  drawVertebralLevelsText(ctx: CanvasRenderingContext2D){
    const nSliceIndexes = this.currentSliceIndexes.length;
    const startIndex = this.additionalInformationDict['vertebralLevels'][0];
    const endIndex = this.additionalInformationDict['vertebralLevels'][1];
    const vertebralLevelsStringIndexes = Array.from(
      { length: (endIndex - startIndex) + 1 },
      (_, i) => startIndex + i
    )
    for (let i=0; i<nSliceIndexes; i++){
      let vertebralLevelsStringIndex = vertebralLevelsStringIndexes[i]
      let vertebralLevelsString = GlobalVariables.additionalDataPopups.vertebralLevels.vertebralLevelsNameList[vertebralLevelsStringIndex]
      let text = vertebralLevelsString + " (" + (this.currentSliceIndexes[i]+1) + ")";
      this.drawText(ctx, text, 5, this.getRowIndex(this.currentSliceIndexes[i])-10, 10)
    }
  }


  initializeCanvasSize(){
    // Canvas right overlay
    this.canvasElementRight_Overlay.nativeElement.width = 512;  
    this.canvasElementRight_Overlay.nativeElement.height = 512; 
    this.canvasElementRight_Overlay.nativeElement.style.width = '512px';  
    this.canvasElementRight_Overlay.nativeElement.style.height = '512px';
    // Canvas left text overlay
    this.canvasElementLeft_TextOverlay.nativeElement.width = 512;  
    this.canvasElementLeft_TextOverlay.nativeElement.height = 512; 
    this.canvasElementLeft_TextOverlay.nativeElement.style.width = '512px';  
    this.canvasElementLeft_TextOverlay.nativeElement.style.height = '512px';
  }


  displayCurrentImageNumber(){
    let ctx = this.canvasElementLeft_TextOverlay.nativeElement.getContext('2d');
    // Clean the existing information
    ctx.clearRect(0, 0, this.canvasElementLeft_TextOverlay.nativeElement.width, 21);
    // Display the information
    let textStr = (this.currentSliceIndex+1).toString() + ' / ' + this.nImagesInSerie.toString()
    this.drawText(ctx, textStr, 5, 21)
  }

 



  // ----- Keyboard actions ----- //
  @HostListener('window:keydown', ['$event'])
  async keyEvent(event: KeyboardEvent) {
    // Si no hay ninguna popup abierta, atiende al evento de tecla pulsada.
    if (!this.dialog.openDialogs.length){
      switch (event.key) {
        case 'ArrowLeft': // Left arrow
          this.updatePositioningImageIndex(-1)
          break;
        case 'ArrowRight': // Right arrow
          this.updatePositioningImageIndex(+1)
          break;
        case 'ArrowUp': // Up arrow
          await this.updateSliceIndex(-1)
          break;
        case 'ArrowDown': // Down arrow
          await this.updateSliceIndex(+1)
          break;
      }
    }
  }






  // ----- Language service subscription ----- //
  subscribeToLanguageService(){
    this.languageService.getCurrentLanguageCode().subscribe(async (currentLanguageCode:string) => {
      this.setApplicationState(this.applicationState)
    });
  }

  


}
